import React from "react";
import "./Welcome.css";

function Welcome() {
  return (
    <div className="welcome-container ">
      <h2 className="title-welcome">
        Vi hoppas att du kan hitta allting du behöver.
      </h2>
      <h3 className="welcome-text">
        Företagets namn fokuserar på att erbjuda dig hög kvalitativ service och
        nöjda kunder - vi kommer att göra allt vi kan för att motsvara dina
        förväntningar.
      </h3>
    </div>
  );
}

export default Welcome;
